module.exports = __webpack_public_path__ + "img/electric_use.991a189f.svg";